import { render, staticRenderFns } from "./layout-form.vue?vue&type=template&id=5f95af4d&"
import script from "./layout-form.vue?vue&type=script&lang=js&"
export * from "./layout-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports